<div class="container-fluid p-0 first-div">
    @if (!isHomeRoute()) {
        <app-header />
    }
    <main>
        <router-outlet />
    </main>
    <app-footer />

    @if (isRouting() || orderSelection.isLoadingPrices() || orderProcessing.isUploading() || fedexService.isPaying() || autoCompleteService.isLoading()) {
        <div class="global-loader-overlay">
            <div class="loader-content">
                <div class="spinner-border loader-spinner" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <p class="loader-text">Loading...</p>
            </div>
        </div>
    }

    @if (orderProcessing.showErrorModal()) {
        <div class="modal fade show d-block order-error-modal-backdrop" tabindex="-1" role="dialog" aria-modal="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content border-0 rounded-4 shadow-lg overflow-hidden">
                    <div class="modal-header border-0 bg-danger text-white py-3 px-4 d-flex align-items-center">
                        <h5 class="modal-title fw-bold mb-0 d-flex align-items-center gap-2">
                            <span class="material-symbols-outlined fs-5">error</span>
                            Order Notice
                        </h5>
                    </div>
                    <div class="modal-body p-4 text-start bg-white">
                        <p class="text-dark mb-0 fs-6" style="line-height: 1.5;">
                            {{ orderProcessing.errorModalMessage() }}
                        </p>
                    </div>
                    <div class="modal-footer border-0 pt-0 pb-4 px-4 bg-white d-flex justify-content-end">
                        <button type="button" class="btn btn-primary fw-bold px-4 py-2 rounded-pill shadow-sm d-flex align-items-center gap-2" (click)="orderProcessing.startNewOrder()">
                            <span>Start a New Order</span>
                            <span class="material-symbols-outlined fs-5">arrow_forward</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    }

    @if (versionCheck.showUpdateModal()) {
        <div class="modal fade show d-block order-error-modal-backdrop" tabindex="-1" role="dialog" aria-modal="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content border-0 rounded-4 shadow-lg overflow-hidden">
                    <div class="modal-header border-0 bg-primary text-white py-3 px-4 d-flex align-items-center">
                        <h5 class="modal-title fw-bold mb-0 d-flex align-items-center gap-2">
                            <span class="material-symbols-outlined fs-5">update</span>
                            Update Notice
                        </h5>
                    </div>
                    <div class="modal-body p-4 text-start bg-white">
                        <p class="text-dark mb-0 fs-6" style="line-height: 1.5;">
                            {{ versionCheck.updateMessage() }}
                        </p>
                    </div>
                    <div class="modal-footer border-0 pt-0 pb-4 px-4 bg-white d-flex justify-content-end">
                        <button type="button" class="btn btn-primary fw-bold px-4 py-2 rounded-pill shadow-sm d-flex align-items-center gap-2" (click)="versionCheck.reload()">
                            <span class="material-symbols-outlined fs-5">refresh</span>
                            <span>Reload Page</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    }
</div>